export async function findPredictions(fields) {
  const predictions = await findAddressesWithGoogle(fields, fields.country?.isoCode || 'US');
  return predictions.map((prediction) => {
    return { description: prediction.description, placeId: prediction.place_id };
  });
}

export async function getPredictionAddress(prediction) {
  const placeDetails = await getDetailsOfPlace(prediction.placeId);
  if (placeDetails.length > 0) {
    return parsePlaceDetails(placeDetails);
  } else {
    return {};
  }
}

// TODO: When showcase moves to new version of placesService we can remove the newPlaceService param
export function parsePlaceDetails(placeDetails, newPlaceService = false) {
  const shortValueKey = newPlaceService ? 'shortText' : 'short_name';
  const longValueKey = newPlaceService ? 'longText' : 'long_name';
  const parsedDetails = {
    address: [
      getAddressPart(placeDetails, 'street_number', longValueKey),
      getAddressPart(placeDetails, 'route', longValueKey)
    ].filter(value => value).join(' '),
    city: getAddressPart(placeDetails, 'locality', longValueKey),
    county: getAddressPart(placeDetails, 'administrative_area_level_2', longValueKey)?.replace(/ County$/, ''),
    state: getAddressPart(placeDetails, 'administrative_area_level_1', shortValueKey),
    zip: getAddressPart(placeDetails, 'postal_code', longValueKey),
  };

  return Object.fromEntries(Object.entries(parsedDetails).filter(entry => entry[1]));
}

function getAddressPart(placeDetails, key, valueKey = 'long_name') {
  const part = placeDetails.find(detail => detail.types.includes(key));

  if (part) {
    return part[valueKey];
  }
}

const getDetailsOfPlace = async (placeId) => {
  // we create a fake div since the PlaceService requires a div to be passed in. we do not need to add it to the DOM
  const fakeDiv = document.createElement('div');
  const service = new google.maps.places.PlacesService(fakeDiv);
  const request = {
    placeId: placeId,
    fields: ['address_components']
  };

  try {
    return await new Promise((resolve, reject) => {
      service.getDetails(request, (place, status) => {
        if (status === google.maps.places.PlacesServiceStatus.OK) {
          resolve(place.address_components);
        } else {
          reject(status);
        }
      });
    });
  } catch {
    return {};
  }
};

const findAddressesWithGoogle = async (formFields, countryIsoCode) => {
  const autocompleteService = new google.maps.places.AutocompleteService();
  const sessionToken = new google.maps.places.AutocompleteSessionToken();

  try {
    return await new Promise((resolve, reject) => {
      autocompleteService.getPlacePredictions(
        {
          input: buildAddress(formFields),
          sessionToken,
          componentRestrictions: { country: countryIsoCode } // add componentRestrictions to filter by country
        },
        (predictions, status) => {
          if (status === google.maps.places.PlacesServiceStatus.OK) {
            resolve(predictions);
          } else {
            reject(status);
          }
        }
      );
    });
  } catch {
    return [];
  }
};

const buildAddress = (formFields) => {
  let fullAddress = `${formFields.address}`;
  if (formFields.city) {
    fullAddress += `, ${formFields.city}`;
  }

  if (formFields.state) {
    fullAddress += `, ${formFields.state}`;
  }

  if (formFields.zip) {
    fullAddress += ` ${formFields.zip}`;
  }

  return fullAddress;
};
